(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lnx-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lnx-code-description')) {
    class LnxCodeDescription extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lnxMounted === 'true') return;

        this.dataset.lnxMounted = 'true';

        this.mount().catch((error) => {
          this.dataset.lnxError = 'true';

          this.dispatchEvent(
            new CustomEvent('lnx:description-error', {
              bubbles: true,
              detail: {
                message: error.message
              }
            })
          );
        });
      }

      async mount() {
        const payload = this.dataset.payload || '';
        const binary = atob(payload);
        const bytes = Uint8Array.from(
          binary,
          (character) => character.charCodeAt(0)
        );
        const markup = new TextDecoder().decode(bytes);
        const template = document.createElement('template');

        template.innerHTML = markup;

        this.removeAttribute('data-payload');
        this.replaceChildren(template.content.cloneNode(true));

        const scripts = Array.from(this.querySelectorAll('script'));

        for (const script of scripts) {
          const replacement = document.createElement('script');

          for (const attribute of script.attributes) {
            replacement.setAttribute(
              attribute.name,
              attribute.value
            );
          }

          replacement.textContent = script.textContent;

          const orderedExternal =
            replacement.hasAttribute('src') &&
            !replacement.hasAttribute('async');

          if (orderedExternal) {
            replacement.async = false;

            await new Promise((resolve) => {
              replacement.addEventListener(
                'load',
                resolve,
                { once: true }
              );

              replacement.addEventListener(
                'error',
                resolve,
                { once: true }
              );

              script.replaceWith(replacement);
            });
          } else {
            script.replaceWith(replacement);
          }
        }

        this.dispatchEvent(
          new CustomEvent('lnx:description-ready', {
            bubbles: true,
            detail: {
              scripts: scripts.length
            }
          })
        );
      }
    }

    customElements.define(
      'lnx-code-description',
      LnxCodeDescription
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-lnx-fd]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const runEnhancementCode = (root) => {
      const content = root.querySelector('[data-lnx-content]');
      if (!content) return;

      content
        .querySelectorAll('script[type="application/lnx+javascript"]')
        .forEach((source) => {
          if (source.dataset.lnxExecuted === 'true') return;

          source.setAttribute('data-lnx-executed', 'true');

          const executable = document.createElement('script');
          const sourceUrl = source.getAttribute('src');

          if (sourceUrl) executable.src = sourceUrl;
          if (source.getAttribute('async') !== null) executable.async = true;
          if (source.getAttribute('defer') !== null) executable.defer = true;

          executable.textContent = source.textContent;
          document.head.appendChild(executable);
          executable.remove();
        });
    };

    const prepareReveal = (root) => {
      if (root.dataset.reveal === 'off') return;

      const content = root.querySelector('[data-lnx-content]');

      if (
        root.dataset.reveal === 'auto' &&
        content &&
        content.children
      ) {
        const textWrapper = content.querySelector(
          ':scope > .text-block, :scope > .rte'
        );

        const candidates = textWrapper
          ? Array.from(textWrapper.children)
          : Array.from(content.children);

        Array.from(content.children).forEach((element) => {
          if (element !== textWrapper) candidates.push(element);
        });

        candidates.forEach((element) => {
          if (!element.matches('style, script')) {
            element.setAttribute('data-lnx-reveal', '');
          }
        });
      }

      const elements = Array.from(
        root.querySelectorAll('[data-lnx-reveal]')
      );

      elements.forEach((element, index) => {
        element.style.setProperty(
          '--lnx-delay',
          `${Math.min(index * 90, 450)}ms`
        );
      });

      if (
        reducedMotion.matches ||
        !('IntersectionObserver' in window)
      ) {
        elements.forEach((element) => {
          element.classList.add('lnx-is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('lnx-is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.08
        }
      );

      elements.forEach((element) => observer.observe(element));
    };

    const prepareParallax = (root) => {
      if (
        root.dataset.parallax !== 'true' ||
        reducedMotion.matches
      ) {
        return;
      }

      const elements = Array.from(
        root.querySelectorAll('[data-lnx-parallax]')
      );

      if (!elements.length) return;

      let queued = false;

      const update = () => {
        queued = false;

        elements.forEach((element) => {
          const rect = element.getBoundingClientRect();
          const speed = Number.parseFloat(
            element.dataset.speed || '0.08'
          );

          const centerOffset =
            rect.top +
            rect.height / 2 -
            window.innerHeight / 2;

          const movement = Math.max(
            -80,
            Math.min(80, centerOffset * speed * -1)
          );

          element.style.setProperty(
            '--lnx-parallax-y',
            `${movement.toFixed(2)}px`
          );
        });
      };

      const requestUpdate = () => {
        if (queued) return;

        queued = true;
        requestAnimationFrame(update);
      };

      update();

      window.addEventListener('scroll', requestUpdate, {
        passive: true
      });

      window.addEventListener('resize', requestUpdate, {
        passive: true
      });
    };

    const initialize = (root) => {
      if (root.dataset.lnxReady === 'true') return;

      root.dataset.lnxReady = 'true';
      root.classList.add('lnx-fd--js');

      prepareReveal(root);
      prepareParallax(root);
      runEnhancementCode(root);

      root.dispatchEvent(
        new CustomEvent('lnx:description-ready', {
          bubbles: true
        })
      );
    };

    const initializeAll = () => {
      document.querySelectorAll(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAll,
        { once: true }
      );
    } else {
      initializeAll();
    }

    document.addEventListener(
      'shopify:section:load',
      initializeAll
    );

    document.addEventListener(
      'shopify:block:select',
      initializeAll
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
